import { buildDemoWritingDnaProfile } from "./demoWritingDnaProfiles";

const evidenceMoment = (timestamp, quote, description, confidence) => ({
  timestamp,
  description,
  quote,
  confidence,
});

const finding = (text, confidence, supportingMoments) => ({
  finding: { text, confidence },
  why: [],
  supporting_moments: supportingMoments,
});

export const SALES_DEMO_CALL_BASE = {
  id: "demo-call-sales-decision-alignment",
  title: "Decision alignment",
  customer_name: "Northstar Labs",
  company: "",
  occurred_at: "2026-08-12T14:00:00.000Z",
  created_at: "2026-08-12T14:00:00.000Z",
  duration: 615,
  filename: null,
  transcript: [
    "Rep: Hi Maya, thanks for jumping back on. I wanted to check where things landed after you shared the product review internally.",
    "Customer: The reaction was positive overall, but Rachel in Finance came back with a pretty basic question: why does this need to happen now?",
    "Rep: Okay. Is she mainly worried about price or about the procurement process?",
    "Customer: Not exactly. We have a big onboarding project starting in September, so she is asking why this should compete for budget this quarter.",
    "Rep: Got it. The automation should save managers a lot of time every week, especially around forecast rollups.",
    "Customer: I know, and I liked the demo. But I do not have a number I can put in front of her.",
    "Rep: We can send over the ROI calculator and some benchmarks from similar teams.",
    "Customer: Maybe. I think she is also asking whether this is a priority at all, not just whether the math can work.",
    "Rep: In discovery you said forecasting takes managers hours every Friday and the rollup still changes before Monday.",
    "Customer: It does, but that does not automatically mean Finance will fund a new tool.",
    "Rep: Fair. What would Rachel need to believe for this to be worth doing this quarter?",
    "Customer: Payback inside six months. And she would want to know it actually improves forecast accuracy, not just saves time.",
    "Rep: Have we ever quantified the current forecast misses or the manager time spent rebuilding the rollup?",
    "Customer: No. We talked about the pain, not the baseline.",
    "Rep: That is on me. I should have done that before the product review.",
    "Customer: Probably. I shared your deck and she basically said, nice, but why now?",
    "Rep: Can we get twenty minutes with her Friday and use your last quarter as the baseline instead of sending another deck?",
    "Customer: Maybe. She will not sit through another product demo.",
    "Rep: Agreed. No demo. We bring two numbers: manager hours and forecast variance, and test whether six-month payback is even realistic.",
    "Customer: That would be useful.",
    "Rep: One more thing. If the numbers work, is Rachel the only remaining approval?",
    "Customer: No, Security still has to review it. I thought I mentioned that.",
    "Rep: You mentioned security review, but I treated it like a later step. How long does it usually take?",
    "Customer: Two to three weeks if they have all the documents. Longer if they do not.",
    "Rep: Then Friday is not just Finance. I will send the security pack today, and Friday we decide if the ROI clears the bar. If it does, we start Security the same day.",
    "Customer: That is better. Send me the pack by four and I will get Rachel's assistant to hold eleven Friday.",
    "Rep: Done. I will send the baseline questions with it so we are not guessing in the meeting.",
    "Customer: Perfect.",
  ].join("\n\n"),
  segments: [
    { start: 0, end: 20, speaker: "Rep", text: "Hi Maya, thanks for jumping back on. I wanted to check where things landed after you shared the product review internally." },
    { start: 20, end: 45, speaker: "Customer", text: "The reaction was positive overall, but Rachel in Finance came back with a pretty basic question: why does this need to happen now?" },
    { start: 45, end: 63, speaker: "Rep", text: "Okay. Is she mainly worried about price or about the procurement process?" },
    { start: 63, end: 90, speaker: "Customer", text: "Not exactly. We have a big onboarding project starting in September, so she is asking why this should compete for budget this quarter." },
    { start: 90, end: 116, speaker: "Rep", text: "Got it. The automation should save managers a lot of time every week, especially around forecast rollups." },
    { start: 116, end: 140, speaker: "Customer", text: "I know, and I liked the demo. But I do not have a number I can put in front of her." },
    { start: 140, end: 162, speaker: "Rep", text: "We can send over the ROI calculator and some benchmarks from similar teams." },
    { start: 162, end: 188, speaker: "Customer", text: "Maybe. I think she is also asking whether this is a priority at all, not just whether the math can work." },
    { start: 188, end: 213, speaker: "Rep", text: "In discovery you said forecasting takes managers hours every Friday and the rollup still changes before Monday." },
    { start: 213, end: 236, speaker: "Customer", text: "It does, but that does not automatically mean Finance will fund a new tool." },
    { start: 236, end: 260, speaker: "Rep", text: "Fair. What would Rachel need to believe for this to be worth doing this quarter?" },
    { start: 260, end: 288, speaker: "Customer", text: "Payback inside six months. And she would want to know it actually improves forecast accuracy, not just saves time." },
    { start: 288, end: 316, speaker: "Rep", text: "Have we ever quantified the current forecast misses or the manager time spent rebuilding the rollup?" },
    { start: 316, end: 337, speaker: "Customer", text: "No. We talked about the pain, not the baseline." },
    { start: 337, end: 358, speaker: "Rep", text: "That is on me. I should have done that before the product review." },
    { start: 358, end: 383, speaker: "Customer", text: "Probably. I shared your deck and she basically said, nice, but why now?" },
    { start: 383, end: 410, speaker: "Rep", text: "Can we get twenty minutes with her Friday and use your last quarter as the baseline instead of sending another deck?" },
    { start: 410, end: 432, speaker: "Customer", text: "Maybe. She will not sit through another product demo." },
    { start: 432, end: 461, speaker: "Rep", text: "Agreed. No demo. We bring two numbers: manager hours and forecast variance, and test whether six-month payback is even realistic." },
    { start: 461, end: 480, speaker: "Customer", text: "That would be useful." },
    { start: 480, end: 503, speaker: "Rep", text: "One more thing. If the numbers work, is Rachel the only remaining approval?" },
    { start: 503, end: 526, speaker: "Customer", text: "No, Security still has to review it. I thought I mentioned that." },
    { start: 526, end: 551, speaker: "Rep", text: "You mentioned security review, but I treated it like a later step. How long does it usually take?" },
    { start: 551, end: 573, speaker: "Customer", text: "Two to three weeks if they have all the documents. Longer if they do not." },
    { start: 573, end: 596, speaker: "Rep", text: "Then Friday is not just Finance. I will send the security pack today, and Friday we decide if the ROI clears the bar. If it does, we start Security the same day." },
    { start: 596, end: 606, speaker: "Customer", text: "That is better. Send me the pack by four and I will get Rachel's assistant to hold eleven Friday." },
    { start: 606, end: 612, speaker: "Rep", text: "Done. I will send the baseline questions with it so we are not guessing in the meeting." },
    { start: 612, end: 615, speaker: "Customer", text: "Perfect." },
  ],
  notes: {},
  analysis: null,
  coaching: null,
  relationship_update: null,
};

export const SALES_DEMO_ANALYSIS = {
  relationship_context: "new_business",
  buying_intent: 58,
  trust_level: 84,
  relationship_strength: 73,
  confidence_level: 66,
  risk_of_churn: null,
  conversation_quality: 74,
  score_reasons: {
    buying_intent: "Maya remains engaged and is willing to bring Finance into a decision call, but the business case and urgency are still unproven.",
    trust_level: "Maya openly challenged the process, repeated Rachel's objection, and disclosed the late Security step without softening it.",
    relationship_strength: "The relationship is constructive enough for Maya to keep coaching the rep through the internal process, despite earlier qualification gaps.",
    confidence_level: "A concrete Finance meeting and Security action were secured, but approval still depends on evidence that has not yet been built.",
    conversation_quality: "The rep initially responded to a priority objection with generic value claims, then recovered by qualifying the economic threshold and the hidden approval process.",
  },
  takeaway: {
    text: "The deal looked healthier than it was. The champion liked the product, but Finance had never been given a quantified reason to act now and Security surfaced late. The rep recovered by replacing another deck with a decision call built around six-month payback, forecast accuracy, and an immediate Security start.",
    confidence: 95,
  },
  commercial_status: {
    stage: { text: "Decision validation", confidence: 93 },
    decision_maker: {
      text: "Maya is the champion; Rachel in Finance is the economic approver, with Security as a required gate",
      confidence: 94,
    },
  },
  deep_dive: {
    stance: [
      finding(
        "The champion is still engaged, but internal approval has shifted from product fit to proving urgency and measurable value.",
        94,
        [
          evidenceMoment(
            "0:20",
            "The reaction was positive overall, but Rachel in Finance came back with a pretty basic question: why does this need to happen now?",
            "Positive product reaction is not translating into a funded priority.",
            95
          ),
          evidenceMoment(
            "9:56",
            "That is better. Send me the pack by four and I will get Rachel's assistant to hold eleven Friday.",
            "Maya remains willing to sponsor a concrete next step when the meeting is reframed around the decision rather than another demo.",
            93
          ),
        ]
      ),
    ],
    tone: [
      finding(
        "Direct and corrective, becoming more collaborative once the rep owns the qualification gaps and changes the plan.",
        91,
        [
          evidenceMoment(
            "5:16",
            "No. We talked about the pain, not the baseline.",
            "Maya directly identifies the missing qualification work instead of protecting the rep from the criticism.",
            92
          ),
          evidenceMoment(
            "7:41",
            "That would be useful.",
            "The tone improves once the rep stops pitching and proposes a decision-focused evidence review.",
            88
          ),
        ]
      ),
    ],
    blockers: [
      finding(
        "The deal has no quantified baseline linking the operational pain to a Finance-grade business case.",
        97,
        [
          evidenceMoment(
            "5:16",
            "No. We talked about the pain, not the baseline.",
            "Discovery established pain but did not quantify the current cost or measurable gap.",
            97
          ),
        ]
      ),
      finding(
        "Security is a mandatory two-to-three-week gate that was treated as a later step instead of part of the close plan.",
        96,
        [
          evidenceMoment(
            "8:23",
            "No, Security still has to review it. I thought I mentioned that.",
            "A required approval step remained outside the active deal plan until late in the process.",
            96
          ),
        ]
      ),
    ],
    objections: [
      finding(
        "Finance does not yet believe the problem is urgent enough to deserve budget this quarter.",
        96,
        [
          evidenceMoment(
            "1:03",
            "We have a big onboarding project starting in September, so she is asking why this should compete for budget this quarter.",
            "The objection is prioritization against another funded initiative, not simple price resistance.",
            96
          ),
        ]
      ),
      finding(
        "Rachel requires payback inside six months and evidence of improved forecast accuracy, not time savings alone.",
        95,
        [
          evidenceMoment(
            "4:20",
            "Payback inside six months. And she would want to know it actually improves forecast accuracy, not just saves time.",
            "The economic approver has a specific financial and operational decision threshold.",
            95
          ),
        ]
      ),
    ],
    risks: [
      finding(
        "The deal can slip even with a positive champion because urgency was never established with the economic approver.",
        95,
        [
          evidenceMoment(
            "5:58",
            "I shared your deck and she basically said, nice, but why now?",
            "A positive product story failed because the internal decision narrative lacked urgency.",
            95
          ),
        ]
      ),
      finding(
        "Sending more generic ROI material would repeat the same mistake: outsourcing the internal sale without first building the customer's numbers.",
        90,
        [
          evidenceMoment(
            "2:20",
            "We can send over the ROI calculator and some benchmarks from similar teams.",
            "The first response again defaults to collateral before the real decision criteria are understood.",
            91
          ),
        ]
      ),
    ],
    opportunities: [
      finding(
        "A short Finance meeting using Northstar's own baseline can turn an abstract priority objection into a real go/no-go decision.",
        94,
        [
          evidenceMoment(
            "6:23",
            "Can we get twenty minutes with her Friday and use your last quarter as the baseline instead of sending another deck?",
            "The rep replaces asynchronous internal selling with direct access to the economic decision.",
            94
          ),
          evidenceMoment(
            "9:33",
            "I will send the security pack today, and Friday we decide if the ROI clears the bar. If it does, we start Security the same day.",
            "Finance validation and Security are finally connected into one dated decision path.",
            95
          ),
        ]
      ),
    ],
  },
};

export const SALES_DEMO_COACHING = {
  empathy_score: 78,
  listening_score: 70,
  control_of_conversation: 62,
  skill_reasons: {
    empathy_score: "You accepted Maya's criticism without becoming defensive and explicitly owned the missing baseline and late Security qualification.",
    listening_score: "You eventually isolated Rachel's real threshold, but your first responses still tried to solve the objection before understanding it.",
    control_of_conversation: "The deal had drifted into champion-led internal selling; you regained control by securing direct Finance access and connecting Security to the decision timeline.",
  },
  what_worked: [
    {
      text: '“What would Rachel need to believe for this to be worth doing this quarter?” — You shifted from defending value to qualifying the economic decision standard.',
      confidence: 97,
      timestamp: "03:56",
    },
    {
      text: '“That is on me. I should have done that before the product review.” — You owned the discovery gap instead of arguing with the champion.',
      confidence: 94,
      timestamp: "05:37",
    },
    {
      text: '“Friday we decide if the ROI clears the bar. If it does, we start Security the same day.” — You finally linked economic approval and the technical gate into a dated close plan.',
      confidence: 95,
      timestamp: "09:33",
    },
  ],
  coaching_moves: [
    {
      title: "Do not outsource the internal sale to your champion",
      confidence: 97,
      situation: '“I know, and I liked the demo. But I do not have a number I can put in front of her.” - Maya is being asked to carry the business case to Finance without a quantified baseline or direct access.',
      timestamp: "01:56",
      better_move: "Before you send collateral for internal forwarding, identify what the absent stakeholder must believe, what evidence they will trust, and whether you can join that conversation directly.",
      example_phrase: "Before I give you another deck to carry internally, what is Rachel going to need to believe for this to become a priority, and can we test that with her directly?",
      why_it_works: "It prevents positive champion sentiment from masquerading as deal progress and exposes whether you actually have access to the decision process.",
    },
    {
      title: "Quantify urgency before the product review",
      confidence: 93,
      situation: '“No. We talked about the pain, not the baseline.” - Discovery established a frustrating workflow but never quantified the cost, forecast impact, or threshold that Finance would use later.',
      timestamp: "05:16",
      better_move: "Quantify the current state while the pain is being discussed. Establish manager hours, forecast variance, cost of misses, and the consequence of doing nothing before you demonstrate a solution.",
      example_phrase: "If nothing changes this quarter, what does the current forecasting process cost you in manager time or missed accuracy, and what would make fixing it financially meaningful?",
      why_it_works: "It creates the business case before the deal reaches Finance instead of trying to manufacture one after the champion has already been asked to justify the purchase.",
    },
  ],
  missed_opportunities: [
    {
      text: '“We can send over the ROI calculator and some benchmarks from similar teams.” — You reached for generic collateral before understanding whether Rachel was questioning price, priority, or measurable outcome.',
      confidence: 95,
      timestamp: "02:20",
    },
    {
      text: '“You mentioned security review, but I treated it like a later step.” — A required two-to-three-week gate was known but never incorporated into the mutual action plan.',
      confidence: 96,
      timestamp: "08:46",
    },
  ],
  questions_to_ask: [
    {
      text: '“We have a big onboarding project starting in September, so she is asking why this should compete for budget this quarter.” — With Rachel on Friday: “What would have to be true in our numbers for this to beat the onboarding project for budget this quarter?”',
      confidence: 96,
      timestamp: "01:03",
    },
    {
      text: '“Payback inside six months. And she would want to know it actually improves forecast accuracy, not just saves time.” — To quantify the business case: “Which forecast misses from last quarter would you actually attribute to the current process, and what is a credible improvement target?”',
      confidence: 93,
      timestamp: "04:20",
    },
    {
      text: '“Two to three weeks if they have all the documents. Longer if they do not.” — Before Security starts: “What documents or controls usually create delays in your review, and can we remove those now?”',
      confidence: 91,
      timestamp: "09:11",
    },
  ],
  negotiation_suggestions: [
    {
      text: "Do not negotiate against an unqualified priority objection. First make the cost of delay, six-month payback threshold, and approval sequence explicit; only then discuss commercial terms.",
      confidence: 95,
    },
  ],
};

const firstPersonDefault = `Spoke with Maya after she shared the product review internally. The product reaction is still positive, but Finance is asking the question we never fully qualified: why now? Rachel wants payback inside six months and evidence that this improves forecast accuracy, not just manager efficiency. We also surfaced that Security is still a required 2–3 week gate.\n\nThe main miss is that we established the forecasting pain in discovery but never built a baseline before the demo. I initially defaulted to offering an ROI calculator, then Maya made it clear that generic material would not solve the priority question. We reframed around Northstar's own manager hours and forecast variance instead.\n\nMaya will hold 11am Friday with Rachel if I send the Security pack by 4pm today. I will also send the baseline questions today. Friday is a decision check, not another demo: test the six-month payback case, and if it clears the bar, start Security the same day.`;

export const SALES_DEMO_NOTE_VARIANTS = {
  first_person: {
    default: firstPersonDefault,
    shorter: `Spoke with Maya. Finance likes the idea but is not convinced it deserves budget now. Rachel needs <6 month payback plus evidence of forecast-accuracy impact, and Security is still a 2–3 week gate. I am sending the Security pack and baseline questions today; Maya is holding Friday 11am with Rachel to test the ROI case and start Security immediately if it clears the bar.`,
    more_professional: `Maya confirmed that product fit remains positive, but Finance has not yet accepted the urgency or business case. Rachel requires sub-six-month payback and measurable forecast impact; Security is also a mandatory 2–3 week step. A Finance decision call is being held Friday at 11am, supported by Northstar-specific baseline data and a Security package sent today.`,
    more_conversational: `Useful reality check with Maya. They still like the product, but Finance is basically asking “nice, but why now?” We never quantified the baseline properly, and Security also surfaced later than it should have. I am sending the pack + baseline questions today and Maya is holding Friday at 11 with Rachel. No demo this time: we test the numbers and either move or stop pretending the deal is further along than it is.`,
    more_detailed: `${firstPersonDefault}\n\nThe turning point was Maya saying we had discussed pain but never the baseline. Friday needs to establish current manager hours, forecast variance, Rachel's exact six-month payback threshold, and whether Security can start immediately if the economics work.`,
  },
  salesforce: {
    default: `Call outcome: Deal still active; Finance validation required.\n\nChampion: Maya remains engaged and will facilitate direct Finance access.\n\nEconomic criteria: <6 month payback and measurable forecast-accuracy improvement.\n\nProcess risk: Security is a required 2–3 week gate and surfaced late.\n\nNext steps: Send Security pack + baseline questions today. Finance decision call Friday 11am. Start Security same day if ROI clears the bar.`,
    shorter: `Deal active but not Finance-approved. Rachel needs <6 month payback + forecast impact; Security 2–3 weeks. Pack today; Finance call Friday 11am; start Security if ROI works.`,
    more_professional: `The opportunity remains active but requires economic validation and immediate process alignment. Finance will review Northstar-specific ROI Friday; Security documentation will be submitted in parallel.`,
    more_conversational: `Still alive, but less advanced than it looked. Maya is in; Finance needs real numbers and Security is still ahead of us. Friday is the real decision call.`,
    more_detailed: `Status: Decision validation.\nChampion: Maya.\nEconomic approver: Rachel / Finance.\nCriteria: <6 month payback + forecast accuracy.\nGate: Security 2–3 weeks.\nNext: Security pack today; baseline questions today; Rachel Friday 11am.`,
  },
  hubspot: {
    default: `Summary\nThe product is positively received, but Finance has not accepted the urgency or quantified value. Rachel requires payback inside six months and evidence of forecast-accuracy improvement. Security is also a required 2–3 week approval step.\n\nNext steps\n• Send Security pack by 4pm today.\n• Send baseline questions for manager hours + forecast variance.\n• Meet Rachel Friday at 11am.\n• Start Security same day if ROI clears the bar.`,
    shorter: `Finance validation required: <6 month payback, forecast impact, Security 2–3 weeks. Pack + baseline today; Rachel Friday 11am.`,
    more_professional: `The opportunity is moving into economic validation. Northstar-specific ROI and the Security timeline must now be resolved before the deal can be treated as decision-ready.`,
    more_conversational: `Maya is still helping, but Finance is not buying the “why now” yet. We need their numbers, not another deck. Friday is the test.`,
    more_detailed: `Summary\nPositive champion sentiment has not translated into economic approval.\n\nDecision criteria\n• Payback inside six months\n• Forecast-accuracy improvement\n• Security approval\n\nActions\n1. Security pack today.\n2. Baseline questions today.\n3. Rachel Friday 11am.\n4. Start Security immediately if approved.`,
  },
  close: {
    default: `Deal still active, but Finance is questioning priority. Rachel needs <6 month payback + proof of forecast impact. We never quantified the baseline before the demo. Security is also a 2–3 week gate. Send Security pack and baseline questions today; Maya holds Friday 11am with Rachel. No demo — use their numbers and start Security same day if ROI clears the bar.`,
    shorter: `Finance needs <6 month payback + forecast impact. Security 2–3 weeks. Pack today; Rachel Friday 11am.`,
    more_professional: `Economic validation and Security are now the critical path. Friday's Finance call will determine whether the opportunity advances.`,
    more_conversational: `Deal is alive, but “liked the demo” was hiding a weak business case. Fix the numbers Friday and start Security immediately if they work.`,
    more_detailed: `Stage: Decision validation\nChampion: Maya\nApprover: Rachel\nRisk: urgency unproven + Security late\nActions: pack today, baseline today, Finance Friday 11am`,
  },
  minimal: {
    default: `Finance has not accepted urgency yet. Rachel requires <6 month payback + forecast impact. Security is a 2–3 week gate. Rep sends the Security pack + baseline questions by 4pm today. Maya holds the Finance call Friday 11am with Rachel.`,
    shorter: `Finance proof + Security required. Rep sends pack + baseline today; Maya holds Rachel Friday 11am.`,
    more_professional: `Economic validation and Security approval remain. Rep sends the pack and baseline today; Maya holds the Finance decision call Friday at 11am with Rachel.`,
    more_conversational: `Still alive. I send the real numbers today; Maya gets Rachel on Friday at 11.`,
    more_detailed: `Status: Active, not validated.\nCriteria: payback + forecast accuracy.\nGate: Security.\nAction owner: Rep — Security pack + baseline today.\nCustomer commitment: Maya — Finance call with Rachel Friday 11am.`,
  },
  executive: {
    default: `Executive summary\nThe opportunity remains viable, but product enthusiasm has outpaced the business case. Finance requires payback inside six months and measurable forecast impact, while Security adds a mandatory 2–3 week gate.\n\nDecision path\nUse Northstar's own baseline with Finance Friday at 11am. If the economics clear the threshold, begin Security immediately rather than adding another sales cycle.`,
    shorter: `Opportunity viable but not economically validated. Finance + Security are now the critical path.`,
    more_professional: `The deal requires direct economic validation and immediate technical-process alignment before forecast confidence can increase.`,
    more_conversational: `The deal looked warmer than it was. Friday tells us if there is actually a fundable case.`,
    more_detailed: `Executive summary\nChampion sentiment remains positive. Finance has not accepted urgency. Security timing is material.\n\nRequired proof\n• <6 month payback\n• Forecast-accuracy impact\n• Security readiness\n• Dated approval sequence`,
  },
  detailed_history: {
    default: `12 Aug 2026 — Decision alignment\nMaya confirmed that the product review landed well, but Rachel in Finance challenged the urgency and asked for a sub-six-month payback case plus evidence of forecast impact. We also surfaced that Security is a required 2–3 week gate. I initially offered generic ROI material, then owned the missing baseline and secured a direct Finance conversation.\n\nSecurity pack + baseline questions go out today. Maya will hold Friday at 11am with Rachel. If ROI clears the bar, Security starts the same day.`,
    shorter: `12 Aug — Finance questioning urgency; Security still required. Pack today; Rachel Friday 11am.`,
    more_professional: `12 Aug 2026 — The opportunity moved from product evaluation into explicit economic and Security validation.`,
    more_conversational: `12 Aug — Good reality check. They like it, but Finance needs proof and Security was later than it should have been. Friday is the real decision call.`,
    more_detailed: `15 Jul — Discovery confirmed painful manual forecast consolidation but did not quantify the baseline.\n29 Jul — Product review was positive; Maya introduced Rachel in Finance and the rep left Maya to forward a deck internally.\n12 Aug — Finance challenged urgency and required <6 month payback + forecast impact. Security surfaced as a 2–3 week gate. Direct Finance validation is now booked for Friday.`,
  },
};

export const SALES_DEMO_NOTE_SCORES_BY_STYLE = {
  first_person: buildDemoWritingDnaProfile({
    overall: 92, human_writing: 95, template_language: 91, business_reasoning: 95,
    negotiation_insight: 94, emotional_accuracy: 91, customer_psychology: 94,
    future_usefulness: 96, writing_dna_similarity: 89, profileConfidence: 70,
    sampleFit: "Strongest fit: candid first-person reasoning and clear ownership. Deviation: slightly more context than the demo sample profile's usual working note.",
  }),
  salesforce: buildDemoWritingDnaProfile({
    overall: 85, human_writing: 76, template_language: 65, business_reasoning: 96,
    negotiation_insight: 94, emotional_accuracy: 74, customer_psychology: 87,
    future_usefulness: 96, writing_dna_similarity: 79, profileConfidence: 70,
    sampleFit: "Strongest fit: explicit decision criteria, owners, and next steps. Deviation: fielded CRM language is more templated than the demo sample profile's natural voice.",
  }),
  hubspot: buildDemoWritingDnaProfile({
    overall: 87, human_writing: 83, template_language: 77, business_reasoning: 92,
    negotiation_insight: 88, emotional_accuracy: 80, customer_psychology: 85,
    future_usefulness: 95, writing_dna_similarity: 85, profileConfidence: 70,
    sampleFit: "Strongest fit: scannable next steps and clear risk framing. Deviation: section-led formatting is less conversational than the demo sample profile.",
  }),
  close: buildDemoWritingDnaProfile({
    overall: 89, human_writing: 91, template_language: 89, business_reasoning: 88,
    negotiation_insight: 91, emotional_accuracy: 77, customer_psychology: 82,
    future_usefulness: 94, writing_dna_similarity: 93, profileConfidence: 70,
    sampleFit: "Strongest fit: direct, compressed, action-led phrasing. Deviation: some relational nuance is traded for speed.",
  }),
  minimal: buildDemoWritingDnaProfile({
    overall: 86, human_writing: 94, template_language: 93, business_reasoning: 79,
    negotiation_insight: 83, emotional_accuracy: 65, customer_psychology: 69,
    future_usefulness: 92, writing_dna_similarity: 95, profileConfidence: 70,
    sampleFit: "Strongest fit: concision, directness, and explicit commitments. Deviation: emotional and motivational context is deliberately thinner.",
  }),
  executive: buildDemoWritingDnaProfile({
    overall: 88, human_writing: 79, template_language: 81, business_reasoning: 97,
    negotiation_insight: 93, emotional_accuracy: 69, customer_psychology: 85,
    future_usefulness: 95, writing_dna_similarity: 83, profileConfidence: 70,
    sampleFit: "Strongest fit: commercial reasoning and decision path. Deviation: tone is more formal and less conversational than the demo sample profile.",
  }),
  detailed_history: buildDemoWritingDnaProfile({
    overall: 91, human_writing: 87, template_language: 84, business_reasoning: 96,
    negotiation_insight: 92, emotional_accuracy: 93, customer_psychology: 93,
    future_usefulness: 98, writing_dna_similarity: 81, profileConfidence: 70,
    sampleFit: "Strongest fit: context continuity and future usefulness. Deviation: the note carries more history than the demo sample profile usually keeps.",
  }),
};

export const SALES_DEMO_NOTE_SCORES = SALES_DEMO_NOTE_SCORES_BY_STYLE.first_person;

export const SALES_DEMO_RELATIONSHIP_DATA = {
  customer: {
    id: "demo-relationship-northstar",
    key: "demo-relationship-northstar",
    name: "Northstar Labs",
    company: "",
    call_count: 3,
    first_call_at: "2026-07-15T13:00:00.000Z",
    last_call_at: "2026-08-12T14:00:00.000Z",
  },
  milestones: [
    {
      call_id: "demo-call-sales-decision-alignment",
      title: "Decision alignment",
      date: "2026-08-12T14:00:00.000Z",
      customer_mood: "Direct, corrective",
      main_objection: "Why now? Finance needs a quantified case",
      objection_status: "critical",
      turning_point: "Maya revealed that Finance was not rejecting the product; Rachel was rejecting an unquantified priority and Security had not been built into the close plan.",
      next_step: "Send Security pack and baseline questions today; meet Rachel Friday at 11am to test the six-month payback case.",
      negotiation_stage: "Decision validation",
      confidence: 58,
      churn_risk: null,
      outcome: "In progress",
      follow_up_email_available: true,
      follow_up_email: {
        subject: "Friday Finance validation + Security next steps",
        body: `Hi Maya,

Thanks again for today. I’ll send the Security pack and baseline questions by 4pm so Rachel has the right inputs ahead of Friday.

For the 11am Finance conversation, I’ll keep us focused on the two points Rachel raised: whether we can credibly show a sub-six-month payback and what the expected forecast-accuracy impact looks like against your current baseline.

If that clears the bar, we can start the Security review the same day and keep the two-to-three-week gate from becoming a late-stage surprise.

Thanks for getting the right people into the room. Speak Friday.`,
        version_kind: "initial",
        generated_at: "2026-08-12T14:20:00.000Z",
      },
      relationship_update: {
        previous_call_id: "demo-call-sales-product-review",
        changes: {
          summary: [
            "Positive product feedback did not translate into Finance urgency",
            "A six-month payback and forecast-accuracy threshold became explicit",
            "Security surfaced as a required two-to-three-week gate",
            "Direct Finance access replaced champion-led internal forwarding",
          ],
        },
      },
    },
    {
      call_id: "demo-call-sales-product-review",
      title: "Product review",
      date: "2026-07-29T15:30:00.000Z",
      customer_mood: "Positive, exploratory",
      main_objection: "Finance still needs to be comfortable",
      objection_status: "persistent",
      turning_point: "Maya said Rachel in Finance would need to be comfortable, but the rep accepted an internal handoff and sent a deck instead of qualifying the decision criteria.",
      next_step: "Maya to share the deck with Rachel and return with feedback.",
      negotiation_stage: "Solution validation",
      confidence: 72,
      churn_risk: null,
      outcome: "In progress",
      relationship_update: {
        previous_call_id: "demo-call-sales-discovery",
        changes: {
          summary: [
            "Product fit strengthened",
            "Finance appeared as a new stakeholder",
            "Decision criteria and access remained unqualified",
          ],
        },
      },
    },
    {
      call_id: "demo-call-sales-discovery",
      title: "Discovery",
      date: "2026-07-15T13:00:00.000Z",
      customer_mood: "Engaged",
      main_objection: "Manual forecasting is painful but impact is not quantified",
      objection_status: "persistent",
      turning_point: "Maya described weekly manager time lost rebuilding forecast rollups and inconsistent numbers before Monday leadership meetings.",
      next_step: "Run a product review focused on forecast consolidation and manager workflow.",
      negotiation_stage: "Discovery",
      confidence: 68,
      churn_risk: null,
      outcome: "Recorded",
      relationship_update: {
        previous_call_id: null,
        changes: {
          summary: [
            "New opportunity established",
            "Forecast consolidation pain was clear",
            "Business impact and approval process remained unquantified",
          ],
        },
      },
    },
  ],
  objection_evolution: [
    { text: "Manual forecasting pain established", status: "resolved" },
    { text: "Finance approval remained unqualified", status: "persistent" },
    { text: "Urgency and six-month payback became critical", status: "critical" },
    { text: "Security timing surfaced late", status: "critical" },
  ],
  relationship_memory: {
    available: true,
    needs_rebuild: false,
    last_processed_call_id: "demo-call-sales-decision-alignment",
    current_state: {
      as_of_call_id: "demo-call-sales-decision-alignment",
      relationship_context: "new_business",
      bookmark: {
        text: "Deal active; Finance proof and Security now define the path",
        tone: "positive",
      },
      facts: {
        customer_position:
          "Maya likes the product and remains a willing champion, but Finance has not accepted the urgency or business case. Rachel requires payback inside six months and measurable forecast-accuracy impact. Security is a mandatory two-to-three-week gate.",
        stakeholders: [
          { name: "Maya", role: "RevOps champion coordinating the evaluation", source_call_id: "demo-call-sales-decision-alignment" },
          { name: "Rachel", role: "Finance economic approver", source_call_id: "demo-call-sales-decision-alignment" },
          { name: "Security", role: "Required technical approval gate", source_call_id: "demo-call-sales-decision-alignment" },
        ],
        commitments: [
          {
            owner: "rep",
            status: "open",
            text: "Send the Security package and baseline questions.",
            deadline: "Today by 4pm",
            source_call_id: "demo-call-sales-decision-alignment",
          },
          {
            owner: "customer",
            status: "open",
            text: "Hold 11am Friday with Rachel for a short Finance decision conversation.",
            deadline: "Friday at 11am",
            source_call_id: "demo-call-sales-decision-alignment",
          },
          {
            owner: "rep",
            status: "open",
            text: "Use Northstar's manager hours and forecast variance to test the six-month payback threshold.",
            deadline: "Friday at 11am",
            source_call_id: "demo-call-sales-decision-alignment",
          },
        ],
        commercial_objections: [
          {
            text: "Finance does not yet believe the problem deserves budget this quarter.",
            status: "open",
            source_call_id: "demo-call-sales-decision-alignment",
          },
          {
            text: "Rachel requires payback inside six months and proof of forecast-accuracy improvement.",
            status: "open",
            source_call_id: "demo-call-sales-decision-alignment",
          },
        ],
        operational_blockers: [
          {
            text: "The discovery process never quantified the current manager-time or forecast-variance baseline.",
            status: "open",
            source_call_id: "demo-call-sales-decision-alignment",
          },
          {
            text: "Security requires two to three weeks and was not previously built into the active decision timeline.",
            status: "open",
            source_call_id: "demo-call-sales-decision-alignment",
          },
        ],
        process_preferences: [
          {
            text: "Rachel will not sit through another product demo; the Finance conversation must stay focused on Northstar's numbers and decision threshold.",
            status: "active",
            source_call_id: "demo-call-sales-decision-alignment",
          },
          {
            text: "Maya responds well when the rep owns process gaps directly instead of defending previous assumptions.",
            status: "active",
            source_call_id: "demo-call-sales-decision-alignment",
          },
        ],
      },
      inferences: {
        buying_intent: { score: 58 },
        churn_risk: {},
        trust: { score: 84 },
        relationship_strength: { score: 73 },
        attitude: {
          text: "Interested, but proof required",
          source_call_id: "demo-call-sales-decision-alignment",
        },
        emotional_tone: {
          text: "Direct, corrective, increasingly collaborative",
          source_call_id: "demo-call-sales-decision-alignment",
        },
        risks: [
          {
            text: "The opportunity can slip behind the onboarding project if Finance still sees the purchase as useful but non-urgent.",
            source_call_id: "demo-call-sales-decision-alignment",
          },
          {
            text: "Security timing can push the deal out even if Finance approves the economics on Friday.",
            source_call_id: "demo-call-sales-decision-alignment",
          },
        ],
        opportunities: [
          {
            text: "Maya is willing to create direct Finance access and start Security immediately if the six-month payback case is credible.",
            source_call_id: "demo-call-sales-decision-alignment",
          },
        ],
      },
    },
    next_call_brief: {
      risks: [
        {
          text: "A generic ROI pitch will repeat the previous internal handoff failure and leave Rachel's priority objection unresolved.",
          source_call_id: "demo-call-sales-decision-alignment",
        },
        {
          text: "If Security does not start immediately after Finance validation, the two-to-three-week review can create avoidable slippage.",
          source_call_id: "demo-call-sales-decision-alignment",
        },
      ],
      opportunities: [
        {
          text: "Friday creates direct access to the economic approver and a chance to turn the deal into an explicit go/no-go against Northstar's own numbers.",
          source_call_id: "demo-call-sales-decision-alignment",
        },
      ],
    },
    prepare_next_call: {
      schema_version: 2,
      generated_at: "2026-08-12T15:00:00.000Z",
      relationship_state_version: 4,
      source_call_count: 3,
      source_call_ids: [
        "demo-call-sales-discovery",
        "demo-call-sales-product-review",
        "demo-call-sales-decision-alignment",
      ],
      latest_call_id: "demo-call-sales-decision-alignment",
      latest_call_at: "2026-08-12T14:00:00.000Z",
      output_language_code: "en",
      last_call_outcome: "Finance validation booked; Security path surfaced",
      relationship_state: "Decision validation",
      next_recommended_action: "Use Friday with Rachel to test Northstar's six-month payback case and, if it clears the threshold, start Security immediately.",
      script_ready: true,
      priority: "high",
      conversation_strategy: "Do not re-demo the product. Lead with Northstar's current manager-time and forecast-variance baseline, ask Rachel to define the funding threshold, and leave with an explicit economic decision plus Security start date.",
      objective: {
        text: "Get an explicit Finance go/no-go on the six-month payback case and align Security as the immediate next gate.",
        confidence: "high",
        basis: "Maya secured twenty minutes with Rachel specifically to test the ROI threshold, and Security can start the same day if the economics work.",
      },
      likely_objections: [
        {
          text: "The onboarding project is a higher priority for this quarter's budget.",
          response_direction: "Compare the cost of delay using Northstar's own manager hours and forecast variance. Do not argue that forecasting is strategically important in the abstract.",
          confidence: "high",
          basis: "Rachel's first objection was why this should compete with the September onboarding initiative.",
        },
        {
          text: "The payback case is too dependent on soft time-savings assumptions.",
          response_direction: "Separate verified manager hours from the forecast-accuracy hypothesis and agree which numbers Finance considers credible enough to fund.",
          confidence: "high",
          basis: "Rachel explicitly requires payback inside six months and wants evidence beyond efficiency claims.",
        },
        {
          text: "Security timing makes this quarter unrealistic anyway.",
          response_direction: "Show that the documentation is already ready and agree to start the review immediately if Finance approves, rather than treating Security as a post-decision task.",
          confidence: "medium",
          basis: "Security normally takes two to three weeks when documentation is complete.",
        },
      ],
      suggested_call_flow: [
        {
          title: "Start with Rachel's question",
          purpose: "Frame the conversation around why this deserves budget now, not around product capabilities.",
        },
        {
          title: "Validate the baseline",
          purpose: "Confirm manager hours, forecast variance, and which numbers Finance accepts as credible.",
        },
        {
          title: "Test the six-month threshold",
          purpose: "Calculate whether the opportunity clears Rachel's explicit payback bar without optimistic assumptions.",
        },
        {
          title: "Resolve the priority trade-off",
          purpose: "Compare the cost of waiting with the onboarding project's competing claim on budget.",
        },
        {
          title: "Connect Finance to Security",
          purpose: "If Finance approves, start Security immediately and leave with a dated technical gate.",
        },
      ],
      questions_to_ask: [
        {
          text: "Rachel, what would have to be true in these numbers for this to beat the onboarding project for budget this quarter?",
          why: "It puts the real prioritization decision in the room instead of asking Maya to translate it later.",
        },
        {
          text: "Which part of the payback case do you consider hard evidence, and which part would you discount?",
          why: "It prevents a superficially positive ROI model from being rejected later because Finance did not trust the assumptions.",
        },
        {
          text: "If the economics clear your bar today, is there any reason we should not start Security immediately?",
          why: "It tests whether another hidden gate exists before the deal is forecast as committed.",
        },
        {
          text: "What happens operationally if Northstar keeps the current forecasting process through Q4?",
          why: "It quantifies the cost of delay without inventing urgency for the customer.",
        },
      ],
      next_call_script: {
        opening: {
          text: "Maya said the product itself is not the question anymore. The question is whether this deserves budget now, so I brought Northstar's baseline rather than another demo. I want to test the six-month payback case with you and be comfortable saying no if the numbers do not support it.",
          why_it_fits: "It mirrors Rachel's actual objection, respects her preference for a non-demo conversation, and lowers resistance by making the meeting diagnostic rather than promotional.",
        },
        mid_call_pivots: [
          {
            trigger: "If Rachel challenges the time-savings assumptions",
            text: "That is fair. Let us separate the manager hours we can verify from the forecast-accuracy impact we still need to prove. Which one would you actually fund against?",
          },
          {
            trigger: "If the onboarding project is raised",
            text: "Rather than argue priority, what would the cost of waiting have to be for this to deserve budget alongside onboarding rather than after it?",
          },
          {
            trigger: "If the economics look positive",
            text: "If this clears your six-month threshold, can we treat Finance as approved and start Security today, or is there another decision step we have not named?",
          },
        ],
        closing: {
          text: "Do we have a Finance-approved case, what assumption still needs validation, and are we starting Security today or moving this out of the quarter?",
          why_it_fits: "It forces an explicit commercial outcome instead of allowing another polite follow-up to masquerade as progress.",
        },
        keep_in_mind: "Maya is still a strong champion, but do not ask her to carry another internal pitch. Rachel needs direct, evidence-based answers and has already signaled low tolerance for another product presentation.",
      },
      personalization: {
        rep_voice_summary: "You are strongest when you acknowledge a miss plainly, ask a direct diagnostic question, and convert ambiguity into a dated next step. The script keeps that directness while preventing an early return to generic value claims.",
        customer_style_summary: "Maya is candid and collaborative but will correct weak assumptions directly. She responds best when the rep owns process gaps and reduces the burden of selling internally on her behalf.",
        adaptation_notes: [
          "Open with the economic question, not a product recap.",
          "Use Northstar's numbers instead of external benchmarks wherever possible.",
          "Ask Rachel for the threshold directly rather than asking Maya to interpret it.",
          "Treat Security as part of the close plan, not post-sale administration.",
          "Close on an explicit go/no-go and dated gate.",
        ],
        rep_voice_confidence: 89,
        customer_style_confidence: 92,
        rep_profile_maturity: "established",
        customer_profile_maturity: "developing",
        rep_sample_call_count: 14,
        customer_sample_call_count: 3,
      },
    },
  },
};
